import type { ELoadingOptions } from "@modules/loader/useLoader.hook";
import type IChampion from "@modules/skins/shared/models/IChampion.model";
import type ISkin from "@modules/skins/shared/models/ISkin.model";
import LOL_API from "./lolFetcher";

const BASE_URL = "/champions";

class ChampionAPI {
  static get = (slug: string, loadingType: ELoadingOptions) =>
    LOL_API.get<IChampion>(`${BASE_URL}/${slug}/skins`, undefined, loadingType);

  static getPopular = (loadingType: ELoadingOptions) =>
    LOL_API.get<ISkin[]>(`${BASE_URL}/popular`, undefined, loadingType);
}

export default ChampionAPI;
